module.exports = __webpack_public_path__ + "static/img/c29893da0f28716495aa2a642ba319d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon4.png
// module id = iAaX
// module chunks = 1